export var v1 = function (_a) {
    var headers = _a.headers;
    return ({
        page: parseInt(headers['x-page'], 10),
        totalRecords: parseInt(headers['x-records'], 10),
        hasMore: parseInt(headers['x-page'], 10) < parseInt(headers['x-pages'], 10),
    });
};
export var v2 = function (_a) {
    var headers = _a.headers;
    return ({
        page: parseInt(headers['x-page'], 10),
        totalRecords: parseInt(headers['x-records'], 10),
        hasMore: parseInt(headers['x-page'], 10) < parseInt(headers['x-pages'], 10),
    });
};
export var v3 = function (_a) {
    var page = _a.page;
    return ({
        page: parseInt(page.pageOffset, 10) + 1,
        hasMore: page.hasMore,
        totalRecords: parseInt(page.count, 10),
    });
};
